import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SidePanel, { useSidePanel } from '@node-space/storybook-components/dist/SidePanel'
import { Badge, Box, Chip, Text } from '@node-space/ui-components'
import { NotificationDestination } from '../types'
import { DestinationItem } from './DestinationItem'
import DestinationSidePanelHeader from './DestinationSidePanelHeader'

interface DestinationsListProps {
  destinations: NotificationDestination[]
}

export const DestinationsList = ({ destinations }: DestinationsListProps) => {
  const { t } = useTranslation()
  const [activeRowId, setActiveRowId] = useState(null)

  const {
    isSidePanelOpen: isDestinationOpen,
    sidePanelData: destinationData,
    paging: pagingDestinationList,
    setIsSidePanelOpen: setIsDestinationOpen,
    updateSidePanel: updateDestination,
  } = useSidePanel(destinations)

  const events = destinationData?.eventCodes

  const onDetailsClick = index => {
    updateDestination(index)
    setIsDestinationOpen(true)
  }

  return (
    <Box flexCol>
      {destinations?.map((destination, index) => {
        return (
          <DestinationItem
            key={destination?.id}
            destination={destination}
            index={index}
            activeRowId={activeRowId}
            onDetailsClick={onDetailsClick}
          />
        )
      })}

      <SidePanel
        isOpen={isDestinationOpen}
        onClose={() => setIsDestinationOpen(false)}
        paging={pagingDestinationList}
        scrollBody={false}
        activeRowId={destinationData?.id}
        onActiveRowChange={id => setActiveRowId(id)}
        sidePanelHeader={{
          customSidePanelHeader: <DestinationSidePanelHeader destinationData={destinationData} />,
        }}
      >
        <Box flex flexCol paddingX={20} paddingY={24} gapY={12}>
          <>
            <Box flex align="center" gap={8}>
              <Text variant="heading-3">{t('integrations.events')}</Text>
              <Badge>{events?.length}</Badge>
            </Box>
            <Box width="full" flex isFlexWrap gap={8}>
              {events?.map?.(event => (
                <Chip key={event} variant="input" label={event} dismissible={false} />
              ))}
            </Box>
          </>
        </Box>
      </SidePanel>
    </Box>
  )
}
